import React, { useReducer } from 'react'
import { Box, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { defaultReducer } from '../../Utils/reducers'
import DefaultModal from '../../Utils/DefaultModal'
import ColorButton from '../../Buttons/ColorButton'
import { PhoneInput } from '../../Utils/MaskedInput';
import { PercentFormatInputDefault } from '../../Utils/PercentInputDefault'
import MegaAutoComplete from '../../Utils/megautocomplete'
import './styles.css'

const EditSellers = ({ data, handleClose, submit, users, sellers }) => {

    const [state, setState] = useReducer(defaultReducer, {
        id: 0,
        seller: '',
        user_id: '',
        comission: '0',
        ...data,
    })
    return (
        <>
            <DefaultModal
                open={true}
                handleClose={handleClose}
                title={<>{Boolean(data.id) ? 'Alterar' : 'Adicionar'} Vendedor</>}
                content={
                    <Box className='item-content-modal noborder'>
                        <MegaAutoComplete
                            fullWidth={true}
                            value={state.seller}
                            onChange={(data) => setState({ seller: data })}
                            noOptionsText={'Digite para procurar um Vendedor'}
                            timeoutUrl='/novopedido/representantes/'
                            timeoutParam='label'
                            filterOptions={options => options.filter(option => option.id !== state.seller?.id && !sellers.includes(option.id))}
                            label='Vendedor'
                            sx={{ maxWidth: '8rem' }}
                        />
                        <Box className='item-profile-row'>
                            <TextField
                                id={'comission'}
                                type="text"
                                label='Comissão máxima'
                                value={state.comission / 100}
                                onChange={({ target }) => setState({ comission: parseInt(target.value * 100) })}
                                fullWidth={false}
                                size='small'
                                InputProps={{
                                    inputComponent: PercentFormatInputDefault,
                                }}
                                onKeyDown={(e) => e.stopPropagation()}
                            />
                        </Box>
                        <FormControl size='small'>
                            <InputLabel id='main-select-users'>Usuário</InputLabel>
                            <Select
                                labelId='main-select-users'
                                label='Vendedor'
                                value={state.user_id}
                                onChange={({ target }) => setState({ user_id: target.value })}
                            >
                                {users.map(user =>
                                    <MenuItem value={user.id}>{user.username}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Box>
                }
                action={
                    <ColorButton onClick={() => submit(state)}>salvar</ColorButton>

                }
            />
        </>
    )
}

export default EditSellers